import React from "react";
import { Card } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import './Services.css';

import developbg from '../images/PageImg/ServiceDevelop-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { ServDevelopProductionImg } from "../assets/ServDevelopData";
import { ServDevelopProductionTxt } from "../assets/ServDevelopData";
import { ServDevelopProcessFlow } from "../assets/ServDevelopData";
import { ServDevelopEquipmentTxt } from "../assets/ServDevelopData";
import { ServDevelopEquipmentImg } from "../assets/ServDevelopData";
import { ServDevelopEquipmentPhoto } from "../assets/ServDevelopData";
import { ServDevelopFactoryArea } from "../assets/ServDevelopData";

import { GoTopBtn } from '../components/GoTopBtn';

function ServiceDevelop() {
  return (
    <div className='services-page container-fluid'>
      <div className='serviceheader'
        style={{ backgroundImage: `url(${developbg})`, height: "auto" }} >
        <HeaderSlide text={'Service / Development'} />
        <h4 className='text-dark'>&nbsp;images/PageImg/ServiceDevelop-page-bg.jpg</h4>
      </div>

      {/* Service Development Production */}
      <section id='servdevelopproduction' className='service-block bg-success-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-primary'>Service / Production </h2>
        <Row>
          <Col lg={5} className='flex-column justify-content-center'> {
            ServDevelopProductionImg.map(idx => {
              return (
                <Row key={idx.id} className='d-flex'>
                  <img src={idx.image} style={{ height: 'auto' }} alt='' />
                  <h5 className='text-warning-emphasis'>{idx.alt}</h5>
                </Row>
              )
            })
          } </Col>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            <Row> {
              ServDevelopProductionTxt.map(prod => {
                return (
                  <Row key={prod.id} className='holder'>
                    <Card className='bg-warning-subtle border-1'>
                      <br />
                      <Card.Title className='fs-2 text-center text-primary'> {prod.title} </Card.Title>
                      <Card.Text className='fs-3 text-center text-primary'> {prod.subtitle} </Card.Text>
                      <Card.Text style={{ whiteSpace: 'pre' }}> {prod.text} </Card.Text>
                    </Card>
                  </Row>
                )
              })
            } </Row>
          } </Col>
        </Row>
      </section>

      {/* Service Develop Process Flow */}
      <section id='servdevelopprocflow' className='block service-block bg-danger-subtle' >
        <h2 className='title-holder fs-1 fw-bold text-primary'>Service / Development</h2>
        <Row>
          <Container fluid className='my-1' > {
            ServDevelopProcessFlow.map(flow => {
              if (flow.image) {
                return (
                  <Row key={flow.id}>
                    <h2 className='text-center text-primary bg-warning'>{flow.title}</h2>
                    <Col lg={8} className="justify-content-center">
                      <img src={flow.image} className='img-fluid' style={{ width: 'auto' }} alt='' />
                      <h4 className='text-warning-emphasis text-center'>{flow.alt}</h4>
                    </Col>
                    <Col lg={4}>
                      <h3 className='text-center text-primary bg-warning-subtle'>{flow.subtitle}</h3>
                      <p className='m-1 fw-bold fs-5' style={{ whiteSpace: 'pre' }}>{flow.text}</p>
                    </Col>
                    <hr />
                  </Row>
                )
              }
              else {
                return (
                  <Row key={flow.id}>
                    <h3 className='m-4 text-center text-success'>{flow.subtitle}</h3>
                    <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre' }}>{flow.text}</p>
                  </Row>
                )
              }
            })
          } </ Container>
        </Row>
      </section>

      {/* Service / Develop Equipment */}
      <section id='servdevelopquip' className='block service-block bg-primary-subtle' >
        <h2 className='servdevelopeqp text-center fw-bold'>Development / Production Equipment</h2>
        <Row>
          <Col lg={5} className='d-flex flex-column'> {
            ServDevelopEquipmentImg.map(idx => {
              return (
                <Row key={idx.id}>
                  <img src={idx.image} style={{ height: 'auto' }} alt='' />
                  <h5 className='text-warning-emphasis'>{idx.alt}</h5>
                  <h5 className='text-warning-emphasis'>{idx.altCHS}</h5>
                </Row>
              );
            })
          } </Col>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            <Row> {
              ServDevelopEquipmentTxt.map(equip => {
                return (
                  <Row key={equip.id} className='holder'>
                    <Card className='bg-discovery-subtle border-1'>
                      <br />
                      <Card.Title className='fs-2 text-center text-primary'> {equip.title} </Card.Title>
                      <Card.Text className='fs-2 text-center text-primary'> {equip.subtitle} </Card.Text>
                      <Card.Text style={{ whiteSpace: 'pre' }}> {equip.text} </Card.Text>
                    </Card>
                  </Row>
                )
              })
            } </Row>
          } </Col>
        </Row>
      </section>

      {/* Service Develop Equipment Photo*/}
      < section id='servdevelopquip' className='service-block equiphoto bg-success-subtle' >
        < div className='title-holder' >
          <h1 className='text-center'>Service / Development</h1>
          <h2 className='fw-bold'>Factory Equipments Photo</h2>
        </div >
        <Container fluid>
          <Row style={{ marginTop: '2%' }}> {
            ServDevelopEquipmentPhoto.map((equip, index) => (
              <Col lg={4} style={{ marginBottom: '3%' }}>
                <Card style={{ width: '25rem', maxheight: '100vh' }}>
                  <Card.Img style={{ height: 'auto' }} variant='top' src={equip.image} />
                  <h5 className='text-center'> {equip.alt} </h5>
                  <Card.Body>
                    <Card.Title className='text-center'>{equip.title}</Card.Title>
                    <Card.Text className='describe text-center'> {equip.describe} </Card.Text>
                    <Card.Text className='detail text-center'> {equip.detail} </Card.Text>
                  </Card.Body>
                </Card>
              </ Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Service Development Factory Area */}
      < section id='servdevelopprodplant' className='service-block bg-danger-subtle' >
        < div className='title-holder text-center' >
          <h1 className='servdeveloparea'>Service / Factory Area</h1>
          <h2 className='fw-bold'>Factory Area</h2>
        </div >
        <Container fluid className='my-1'> {
          ServDevelopFactoryArea.map(area => {
            return (
              <Container fluid>
                <Row key={area.id} className='image justify-content-around'>
                  <h2 className='m-1 text-center text-success bg-warning'>{area.title}</h2>
                  <img src={area.image} alt={area.alt} />
                  <h4 className='text-warning-emphasis text-center'>{area.alt}</h4>
                </Row>
                <Row key={area.id}>
                  <Col lg={2}></Col>
                  <Col lg={8}>
                    <h2 className='m-1 text-center text-success bg-warning-subtle'>{area.subtitle}</h2>
                    <p className='m-1 fw-bold fs-4' style={{ whiteSpace: 'pre-wrap' }}>{area.text}</p>
                  </Col>
                  <Col lg={2}></Col>
                </Row>
              </Container>
            )
          })
        } </Container>
      </section>

      <div> < GoTopBtn /> </div>
    </div >
  );
}

export default ServiceDevelop;

// function ServiceDevelop() {
//   // console.log("get into function ServiceDevelop()");
//   return (
//   )
// )

// import { ServDevelopTopImg } from "../assets/ServDevelopData";
// {/* Service Development Header */}
// {/* <Container fluid className='d-flex justify-content-center'> */}
// <Container fluid className='d-flex'>
//   <header className='mt-1'>
//     <h1 className='servdevelop'>Service / Development</h1>
//     <h5 className='text-warning'>PageImg/services-page.jpg</h5>
//     <h5 className='text-warning'>ServiceImg/DevelopTop/ServDevelop.jpg</h5>
//   </header>
// </Container>

// <section id='servdeveloptop' className='block service-block bg-discovery-subtle'>
//   <Container fluid>
//     <h2 className='title-holder fs-1 fw-bold text-primary'>Service Development</h2>
//     <Row className='d-flex justify-content-around'> {
//       ServDevelopTopImg.map(idx => {
//         return (
//           <Col lg={4} key={idx.id} className='flex'>
//             <img src={idx.image} style={{ height: 'auto', width: '40vw' }} alt='' />
//             // <img src={img.image} style={{ height: '60vh', width: '40vw' }} alt='' />
//             <h5 className='text-danger-emphasis'>{idx.alt}</h5>
//           </Col>
//         )
//       })
//     } </Row>
//   </Container>
// </section>

// function CardPage() {
//   let cardArr = config;
//   return (
//     <div className='row' style={{ marginTop: '4%', marginLeft: '2%' }}> {
//       cardArr.map((eachCard, index) => (
//         <div className='col-md-3' style={{ marginBottom: '4%' }}>
//           <Card style={{ width: '18rem', height: '65vh' }}>
//             <Card.Img style={{ height: '20vh' }} variant="top" src={require('./images/' + eachCard.img + '.jpg')} />
//             <Card.Body>
//               <Card.Title>{eachCard.title}</Card.Title>
//               <Card.Text style={{ height: '27vh' }}> {eachCard.text} </Card.Text>
//               <Button variant="primary" href={`${eachCard.link}`}>Info</Button>
//             </Card.Body>
//           </Card>
//         </div>
//       ))
//     } </div>
//   )
// }

// {/* Service Develop Equipment Photo*/}
// <Row> {
//   ServDevelopEquipmentPhoto.map(equip => {
//     if (equip.id !== 0) {
//       return (
//         <Col sm={4} key={equip.id}>
//           <Row className='image d-flex justify-content-around'>
//             <img style={{ height: 'auto' }} src={equip.image} className='' alt="" />
//             // <img style={{ height: '55vh' }} src={equip.image} className='' alt="" />
//             <h4 className='text-warning-emphasis'>{equip.alt}</h4>
//           </Row>
//           <Row className='text-center'>
//             <p className='fs-4 fw-bold'>{equip.title}</p>
//             <p className='fs-5'>{equip.subtitle}</p>
//             // <p className='fs-4'>{equip.describe}</p>
//             <p className='fs-6'>{equip.text}</p>
//           </Row>
//         </ Col>
//       )
//     }
//     else {
//       return (
//         <Row key={equip.id} className='text-center'>
//           <h2 className='fw-bold'>{equip.title}</h2>
//           <h3>{equip.describe}</h3>
//           <h2 style={{ whiteSpace: 'pre-wrap' }}>{equip.text}</h2>
//         </Row>
//       )
//     }
// } </ Row>

// {/* Service / Develop Equipment */}
// <section id='servdevelopquip' className='block service-block bg-primary-subtle' >
//   <Row>
//     <Col lg={3} className='flex-column'> {
//       ServDevelopEquipmentImg.map(img => {
//         return (
//           <Row key={img.id} className='d-flex'>
//             <img style={{ width: '50vw' }} src={img.image} alt='' />
//             <h3 className='text-warning-emphasis'>{img.alt}</h3>
//           </Row>
//         )
//       })
//     } </Col>
//     <Col lg={9} className='d-flex flex-column justify-content-around'> {
//       ServDevelopEquipmentTxt.map(equip => {
//         return (
//           <Row key={equip.id} className='holder'>
//             <Card className='bg-warning-subtle border-1 p-0 m-0'>
//               <br />
//               <Card.Title className='fs-2 text-center text-primary'> {equip.title} </Card.Title>
//               <Card.Text className='fs-2 text-center text-primary'> {equip.subtitle} </Card.Text>
//               <Card.Text style={{ whiteSpace: 'pre' }}> {equip.text} </Card.Text>
//             </Card>
//           </Row>
//         )
//       })
//     }
//     </Col>
//   </Row>
// </section >

// <h1 className='title-holder fw-bold text-primary'>Service / Development</h1>

// <section id='servdevelopquip' className='service-block equiphoto bg-success-subtle' >
//   < div className='title-holder' >
//     <h1 className='text-center'>Service / Development</h1>
//     {/* <hr /> <hr /> */}
//     <h2 className='fw-bold'>Factory Equipments Photo</h2>
//   </div >
//   {/* <Container fluid className='d-flex'> */ }
//   <Container fluid>
//
//   </Container>

// <div className='row' style={{ marginTop: '4%', marginLeft: '2%' }}>
//  {/* <div className='col-md-4' style={{ marginBottom: '4%' }}> */}

//  <Card.Img style={{ height: 'auto' }} variant='top' src={equip.image} />
//  {/* <Card.Img style={{ height: 'auto' }} variant="top" src={equip.image} /> */ }


// < div className='title-holder text-center' >
//   <h1 className='servdeveloparea'>Service / Factory Area</h1>
//   {/* <hr /> <hr /> */}
//   <h2 className='fw-bold'>Factory Area</h2>
// </div >
